export default __webpack_public_path__ + "static/media/7.df74c8fd.jpg";